import React, { useState, useCallback, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import CloseButton from '../../common/CloseButton';
import { ReactSortable } from 'react-sortablejs';
import PMediaExisting from '../../common/PMediaExisting';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { connect, useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/actions';
import { toFixedTrunc } from '../../utils/helper';
import currency from 'currency.js';
import Stash from '../../common/Stash';
import { setStash, setStashSelectedR, setStashShow } from '../../../redux/actions/stash';
import RoundCheckbox from '../../common/RoundCheckbox';
import { ModalPPVPriceContext } from '../../common/ModalPPVPrice/context';
import TimedPricing from '../../common/TimedPricing';
import { ppvPrice as DefaultPpvPrice } from '../../utils/rules';
import moment from 'moment';

const WelcomeModal = ({
    files,
    stash,
    showStash,
    show,
    setShow,
    fetch,
    setFetch,
    activeWelcome = {},
    setActiveWelcome,
    settings
}) => {
    const dispatch = useDispatch();
    const maxFiles = 1;
    const maxFileSize = 1610612736; // 1.5GB
    const userInformation = JSON.parse(localStorage.getItem('user'));
    const [welcomeMessage, setWelcomeMessage] = useState('');
    const [welcomePrice, setWelcomePrice] = useState('');
    const [errors, setErrors] = useState({});
    const [thumbnails, setThumbnails] = useState([]);
    const [busy, setBusy] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [progressbar, setProgressbar] = useState([]);
    const [fileError, setFileError] = useState({});
    const [uploads, setUploads] = useState(0);
    const [filesizeErrors, setFilesizeErrors] = useState('');
    const [hasError, setHasError] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [hasFreePreview, setHasFreePreview] = useState(false);
    const [freePreview, setFreePreview] = useState({});
    const [reshuffled, setReshuffled] = useState(0);
    const [showPrice, setShowPrice] = useState(false);
    const [promoPrice, setPromoPrice] = useState('');
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [showPriceInfo, setShowPriceInfo] = useState(false);
    const [expiry, setExpiry] = useState({
        days: 0,
        hours: 0,
        minutes: 0
    });

    const dispatchAlert = (body, type, title = '') => {
        dispatch(setAlert({
            body,
            type,
            title,
            show: true,
        }));
    }

    // !!! remove this function
    const handlePriceUpdate = (value) => {
        if (value > 0) {
            let price = value.toString().replace(/^0+/, '');
            price = price.replace(/[\.\%]/g, function (match, offset, all) {
                return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
            });

            setWelcomePrice(toFixedTrunc(price, 2));
        } else {
            setWelcomePrice(0);
        }
    }

    useEffect(() => {
        getSettings();
    }, []);

    useEffect(() => {
        let mounted = true;
        if (showPrice) {
            setShowPriceInfo(false);

            // reset date and time to the current datetime + 1 hour show price modal is opened and promoPrice if there is no promo price
            if(!promoPrice) {
                resetExpiry();
            }
        } else {
            if(welcomePrice > 0) {
                setShowPriceInfo(true);
            }

            if(!promoPrice) {
                setIsDiscounted(false);
            }
        }

        return () => {
            mounted = false;
            setShowPriceInfo(false);
        };
    }, [showPrice]);

    const [minPpvPrice, setMinPpvPrice] = useState(DefaultPpvPrice.minAmount);
    const [maxPpvPrice, setMaxPpvPrice] = useState(DefaultPpvPrice.maxAmount);
    const getSettings = async () => {
        await axios.get(`/api/settings`, {
            params: {
                only: 'min_ppv_price,max_ppv_price'
            }
        })
            .then(response => {
                const data = Object.assign({}, ...response.data);
                const minPpv = Object.keys(data).length > 0 && data.min_ppv_price
                    ? data.min_ppv_price
                    : DefaultPpvPrice.minAmount;
                setMinPpvPrice(parseFloat(minPpv));

                const maxPpv = Object.keys(data).length > 0 && data.max_ppv_price
                    ? data.max_ppv_price
                    : DefaultPpvPrice.maxAmount;
                setMaxPpvPrice(parseFloat(maxPpv));
            });
    };

    useEffect(() => {
        let mounted = true;

        if (filesizeErrors.length > 0) {
            let tmp = `<p>The media file you tried to upload is too big.  The maximum size is ${bytesToSize(maxFileSize)}</p><ul>`;
            filesizeErrors.forEach(error => {
                tmp += `<li>Media file name: ${error.filename}</li>`;
            });
            tmp += '</ul><p>Tip: Try trimming your media and upload again.</p>';

            dispatchAlert(tmp, '', 'Media file is too big to upload');
        }

        return () => {
            mounted = false;
        };
    }, [filesizeErrors]);

    useEffect(() => {
        if (activeWelcome && Object.keys(activeWelcome).length > 0) {
            setWelcomeMessage(activeWelcome.wm_caption);
            setWelcomePrice(activeWelcome.wm_price);

            if (activeWelcome.free && Object.keys(activeWelcome.free).length > 0) {
                setHasFreePreview(true);
                setFreePreview(activeWelcome.free);
            }

            if (activeWelcome.medias && activeWelcome.medias.length > 0) {
                dispatch(setStashSelectedR(activeWelcome.medias));
            }

            if(activeWelcome.promo_price) {
                setPromoPrice(activeWelcome.promo_price);
                setIsDiscounted(true);
            } else {
                setPromoPrice('');
                setIsDiscounted(false);
            }

            if(activeWelcome.duration) {
                let minutes = activeWelcome.duration;

                const days = Math.floor(minutes / 1440);
                minutes %= 1440;

                const hours = Math.floor(minutes / 60);
                minutes %= 60;
                setExpiry({
                    days, hours, minutes
                });
            }
        }
    }, [activeWelcome]);

    const handleOnSort = () => {
        if (hasFreePreview && welcomePrice > 0) {
            setReshuffled(reshuffled => reshuffled + 1);
        }
    };

    useDidMountEffect(() => {
        setFreePreview(files[0]);
    }, [reshuffled]);

    const handleHide = () => {
        if (busy || isUploading) {
            return;
        }
        setShow(false);
        setActiveWelcome({});
        setWelcomeMessage('');
        setWelcomePrice('');

        dispatch(setStashSelectedR([]));
    };

    const handleCaption = (e) => {
        setWelcomeMessage(e.target.value);
        setErrors({
            ...errors,
            welcome_caption: null
        });
    };

    const handleWelcomePrice = (e) => {
        let wmPrice = e.target.value;

        if (wmPrice > 0) {
            let price = wmPrice.toString().replace(/^0+/, '');
            price = price.replace(/[\.\%]/g, function (match, offset, all) {
                return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
            });
            setWelcomePrice(price);
        } else {
            setWelcomePrice(wmPrice);
        }
    };

    useEffect(() => {
        if (welcomePrice > 0) {
            if (welcomePrice > parseFloat(settings.max_ppv_price)) {
                setErrors({
                    ...errors,
                    welcome_price: `Max ${currency(settings.max_ppv_price).format({ precission: 2 })} USD`
                });

                return;
            }

            if (welcomePrice < parseFloat(settings.min_ppv_price)) {
                setErrors({
                    ...errors,
                    welcome_price: `Min ${currency(settings.min_ppv_price).format({ precission: 2 })} USD`
                });

                return;
            }

            setErrors({
                ...errors,
                welcome_price: null
            });
        }
    }, [welcomePrice]);

    const submitWelcomeMessage = async (e) => {
        e.preventDefault();

        let payload = {
            welcome_caption: welcomeMessage,
            welcome_price: welcomePrice,
            promo_price: promoPrice,
            duration: expiry
        };

        if (files.length > 0) {
            console.log({ files });
            payload.medias = files.map(file => file.media_id);
        }

        if (freePreview && Object.keys(freePreview).length > 0) {
            payload.free_preview = freePreview.media_id;
        }

        if (activeWelcome && activeWelcome.id) {
            if (!welcomeMessage && files.length <= 0) {
                setErrors({
                    welcome_caption: 'Please enter a welcome message'
                });

                return;
            }
        }

        setBusy(true);

        if (activeWelcome && Object.keys(activeWelcome).length > 0) {
            axios.patch(`/api/welcome-messages/${activeWelcome.id}`, payload)
                .then(response => {
                    console.log({ response });
                    setBusy(false);
                    setFetch(fetch => fetch + 1);
                    setShow(false);
                    resetForm();
                    setActiveWelcome({});

                    const payload = {
                        filter: 'all',
                        show: false,
                        activeAlbum: '',
                        sidebar: false,
                        tabSelected: 'media',
                        albums: [],
                        medias: [],
                        hasMore: true,
                        selected: [],
                        busy: false,
                        mediaSent: [],
                        mediaSold: [],
                        stashSidebar: false,
                        albumAction: '',
                        stashSelected: []
                    };

                    dispatch(setStash({
                        ...stash,
                        ...payload
                    }));
                })
                .catch(error => {
                    setBusy(false);
                    console.error({ error });

                    if (error.response && error.response.status === 422) {
                        let tmp = {};
                        Object.keys(error.response.data.errors).forEach((key) => {
                            tmp[key] = error.response.data.errors[key][0];
                        });
                        setErrors(tmp);
                    }
                });
        } else {
            axios.post('/api/welcome-messages', payload)
                .then(response => {
                    console.log({ response });
                    setBusy(false);
                    setFetch(fetch => fetch + 1);
                    setShow(false);

                    const payload = {
                        filter: 'all',
                        show: false,
                        activeAlbum: '',
                        sidebar: false,
                        tabSelected: 'media',
                        albums: [],
                        medias: [],
                        hasMore: true,
                        selected: [],
                        busy: false,
                        mediaSent: [],
                        mediaSold: [],
                        stashSidebar: false,
                        albumAction: '',
                        stashSelected: []
                    };

                    dispatch(setStash({
                        ...stash,
                        ...payload
                    }));
                })
                .catch(error => {
                    setBusy(false);
                    console.error({ error });

                    if (error.response && error.response.status === 422) {
                        let tmp = {};
                        Object.keys(error.response.data.errors).forEach((key) => {
                            tmp[key] = error.response.data.errors[key][0];
                        });
                        setErrors(tmp);
                    }
                });
        }

    };

    const handleSort = (newState) => {
        const ranked = newState.map((state, index) => {
            return {
                ...state,
                rank: index
            };
        });

        dispatch(setStashSelectedR([...ranked]));
    };

    const handleRemove = (file) => {
        const index = files.findIndex(item => item.media_id == file.media_id);

        if (index >= 0) {
            files.splice(index, 1);
        }

        dispatch(setStashSelectedR([...files]));
    };

    const handleClear = (e) => {
        e.preventDefault();
        resetForm();
    };

    const resetExpiry = () => {
        setExpiry({
            days: 0,
            hours: 0,
            minutes: 0
        });
    }

    const resetPriceModal = () => {
        setWelcomePrice('');
        setPromoPrice('');
        resetExpiry();
        setIsDiscounted(false);
        setFiles([]);
        setCaption('');
        setPostId('');
        setTotalMedia(0);
        setUploads(0);
        setSelectedDate(new Date());
        setIsLoading(false);
        setDiscard(true);
        dispatch(setSelectedPost({}));
        setSelectedCategories([]);
        setFilteredCategories([]);
        setShowPrice(false);
        dispatch(setStashSelectedR([]));
        dispatch(setPostAction(''));
        resetPriceModal();
    }

    const resetForm = () => {
        setWelcomeMessage('');
        setWelcomePrice('');
        setErrors({});
        dispatch(setStashSelectedR([]));
        resetPriceModal();
    };

    const handleAddMedia = (e) => {
        e.preventDefault();
        dispatch(setStashShow(true));
    };

    const handleFreePreview = useCallback(() => {
        setHasFreePreview(hasFreePreview => !hasFreePreview);
    }, [hasFreePreview]);

    useEffect(() => {
        if (!hasFreePreview) {
            handleSelectFreePreview({});
        } else {
            setReshuffled(reshuffled => reshuffled + 1);
        }
    }, [hasFreePreview]);

    const handleSelectFreePreview = useCallback((media) => {
        if (Object.keys(media).length > 0) {
            if (media.media_id == freePreview.media_id) {
                setFreePreview({});
            } else {
                setFreePreview(media);
                const index = files.findIndex(s => s.media_id == media.media_id);
                let tmp = [...files];
                if (index >= 0) {
                    const selected = tmp.splice(index, 1);
                    tmp.unshift(selected[0]);
                }

                dispatch(setStashSelectedR([...tmp]));
            }
        } else {
            setFreePreview({});
        }
    }, [files, freePreview]);

    const handleSelect = (file) => {
        if (hasFreePreview) {
            handleSelectFreePreview(file);
        }
    };

    const updateThumbnailHandler = () => { };

    return <React.Fragment>
        <Modal
            show={show}
            onHide={handleHide}
            className="welcome-modal"
            scrollable={true}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <CloseButton
                    onClick={handleHide}
                    className='close'
                    style={{
                        position: 'absolute',
                        right: 10,
                        top: 10
                    }}
                />

                <div className='welcome-message'>
                    <div className="form-group row">
                        <label htmlFor="welcomeMessage" className="col-sm-12 col-form-label">Welcome Message</label>
                        <div className="col-sm-12">
                            <textarea
                                className=''
                                id="welcomeMessage"
                                rows={4}
                                onChange={handleCaption}
                                disabled={busy}
                                value={welcomeMessage}
                            />
                            {
                                errors.welcome_caption && <div className='text-danger'>
                                    {errors.welcome_caption}
                                </div>
                            }
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="welcome_media" className="col-sm-12 col-form-label">Optional Attachment</label>
                        <div className="col-sm-12">
                            <div
                                className="welcome-message-media-btn"
                            >
                                <button
                                    onClick={handleAddMedia}
                                    style={{
                                        border: 0,
                                        backgroundColor: 'transparent',
                                        color: '#0097fe',
                                        fontSize: '32px'
                                    }}
                                >
                                    <i className="fa-regular fa-photo-film"></i>
                                </button>
                            </div>

                            {
                                welcomePrice > 0 && files.length > 1 && <div className="free-preview mb-0 mt-2 pl-0">
                                    <RoundCheckbox
                                        label="Free Preview"
                                        checked={hasFreePreview}
                                        onChange={handleFreePreview}
                                    />
                                </div>
                            }

                            {
                                errors.medias && <div className='text-danger'>
                                    {errors.medias}
                                </div>
                            }

                            <div className="files mt-1">
                                {
                                    files && files.length > 0 && <ReactSortable
                                        tag="div"
                                        className="files__container"
                                        list={files}
                                        setList={(newState) => handleSort(newState)}
                                        animation={200}
                                        onChoose={() => { setIsDragging(true); }}
                                        onUnchoose={() => { setIsDragging(false); }}
                                        draggable=".files__file"
                                        handle=".free-preview__movable"
                                        delayOnTouchOnly={true}
                                        delay={2}
                                        swap
                                        onSort={handleOnSort}
                                    >
                                        {
                                            files && files.length > 0 && files.map((file, index) => (
                                                <div key={index} className="files__file">
                                                    <div className={`media-${file.media_id}`} style={{
                                                        position: 'relative'
                                                    }}>
                                                        <PMediaExisting
                                                            file={file}
                                                            index={index}
                                                            remove={handleRemove}
                                                            updateThumbnailHandler={updateThumbnailHandler}
                                                            playable={false}
                                                            removable
                                                        />
                                                        <div className='free-preview__movable'>
                                                            <i className="fa-solid fa-grip-dots"></i>
                                                        </div>

                                                        {file.media_id == freePreview.media_id && <span className="free-preview__label">
                                                            Free Preview
                                                        </span>}

                                                        {hasFreePreview && <span
                                                            className={`free-preview__select${file.media_id == freePreview.media_id ? ' free-preview__select-active' : ''}`}
                                                            onClick={() => handleSelect(file)}
                                                        ></span>}
                                                    </div>
                                                    <div className="draggable d-block d-md-none d-lg-none d-xl-none">
                                                        <div
                                                            onClick={(e) => handleRemove(file)}
                                                            style={{
                                                                textAlign: 'center',
                                                                padding: '4px',
                                                                background: '#fe7676',
                                                                color: '#fcfcfc',
                                                                fontSize: '11px',
                                                                borderRadius: '8px',
                                                                marginTop: '4px',
                                                                cursor: 'pointer',
                                                            }}>
                                                            REMOVE
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </ReactSortable>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="welcomePrice" className="col-sm-12 col-form-label">Optional Pay Per View</label>
                        <div className="col-sm-6 d-flex align-content-center welcome-price">
                            <ModalPPVPriceContext.Provider value={{
                                welcomePrice,
                                setWelcomePrice,
                                promoPrice,
                                setPromoPrice,
                                isDiscounted,
                                setIsDiscounted,
                                minPpvPrice,
                                maxPpvPrice,
                                expiry,
                                setExpiry,
                                // dispatchAlert,
                            }}>
                                <TimedPricing />
                            </ModalPPVPriceContext.Provider>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-primary btn-rounded"
                    onClick={handleHide}
                    disabled={busy || isUploading}
                >Cancel</button>
                <button
                    className="btn btn-primary btn-rounded"
                    disabled={busy || isUploading}
                    onClick={handleClear}
                >Clear</button>
                <button
                    type="button"
                    className="btn btn-primary btn-rounded"
                    onClick={submitWelcomeMessage}
                    disabled={busy || errors.welcome_price || errors.media_id || isUploading}
                >
                    {busy ? 'Saving...' : 'Save'}
                </button>
            </Modal.Footer>
        </Modal>
        {showStash && <Stash source="welcome_message" onMessageOrPost={true} />}
    </React.Fragment>;
};

const mapStateToProps = (state) => {
    return {
        settings: state.privaGlobal.settings,
        showStash: state.stash.show,
        stash: state.stash,
        files: state.stash.stashSelected
    };
};

export default connect(mapStateToProps)(React.memo(WelcomeModal));